<template>
  <div>
    <div
      v-if="!isRoot && $can(child.action, child.resource) && canViewVerticalNavMenuLink(child)"
      class="my-1 "
    >
      <feather-icon
        :icon="child.icon"
        size="14"
      />

      <span
        class="m-1 set-cursor"
        @click="$router.push({ name: child.route })"
      >{{ child.title }}</span>
    </div>

    <ul v-if="child.children && child.children.length">
      <child
        v-for="(chid, ind) in child.children"
        :key="ind"
        :child="chid"
        :is-root="false"
      />
    </ul>
  </div>
</template>

<script>
import { canViewVerticalNavMenuLink } from '@/@core/libs/acl/utils'

export default {
  name: 'Child',
  props: {
    child: {
      type: Object,
      default: () => ({}),
    },
    isRoot: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    return {
      canViewVerticalNavMenuLink,
    }
  },
}
</script>

<style scoped>
.set-cursor{
    cursor: pointer;
}
</style>
